import { render } from "./DueSales.vue?vue&type=template&id=8a0e4d32&scoped=true"
import script from "./DueSales.vue?vue&type=script&lang=js"
export * from "./DueSales.vue?vue&type=script&lang=js"

import "./DueSales.vue?vue&type=style&index=0&id=8a0e4d32&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a0e4d32"]])

export default __exports__